import Styles from './Section.module.scss'
import { PropsWithChildren, useState } from 'react'
import { SectionProps } from './Types'
import { SectionHeader } from 'blaze-components/WorkspaceDashboardSidebar/components/SectionHeader/SectionHeader'

export const Section = ({ title, children }: PropsWithChildren<SectionProps>) => {
  const [expanded, setExpanded] = useState(true)

  return (
    <div className={Styles.section}>
      <SectionHeader label={title} isExpanded={expanded} onPress={() => setExpanded((prev) => !prev)} />
      {expanded && children}
    </div>
  )
}
